<template>
    <div>
        <div style="width: 90%">
            <b-card bg-variant="light">
                <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="First Name" label-for="input-sm">
                    <b-form-input id="input-sm" size="sm" v-model="firstName"></b-form-input>
                </b-form-group>


                <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Last Name" label-for="input-sm">
                    <b-form-input id="input-sm" size="sm" v-model="lastName"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Telephone Number" label-for="input-sm">
                    <b-form-input id="telephoneNumber" size="sm" v-model="telephoneNumber"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Company" label-for="input-sm">
                    <b-form-input id="input-sm" size="sm"  v-model="company"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Email Address"
                              label-for="input-sm">
                    <b-form-input id="input-sm" size="sm" v-model="email"></b-form-input>
                </b-form-group>
            </b-card>
        </div>
        <div style="width: 90%">
            <b-card bg-variant="light">
                <b-form-group
                        label-cols-lg="3"
                        label="Business Address"
                        label-size="lg"
                        label-class="font-weight-bold pt-0"
                        class="mb-0"
                >
                    <b-form-group
                            label-cols-sm="3"
                            label="Street:"
                            label-align-sm="right"
                            label-for="nested-street"
                    >
                        <b-form-input id="nested-street"></b-form-input>
                    </b-form-group>

                    <b-form-group
                            label-cols-sm="3"
                            label="City:"
                            label-align-sm="right"
                            label-for="nested-city"
                    >
                        <b-form-input id="nested-city"></b-form-input>
                    </b-form-group>

                    <b-form-group
                            label-cols-sm="3"
                            label="State:"
                            label-align-sm="right"
                            label-for="nested-state"
                    >
                        <b-form-input id="nested-state"></b-form-input>
                    </b-form-group>

                    <b-form-group
                            label-cols-sm="3"
                            label="Country:"
                            label-align-sm="right"
                            label-for="nested-country"
                    >
                        <b-form-input id="nested-country"></b-form-input>
                    </b-form-group>
                </b-form-group>
            </b-card>
        </div>
    </div>

</template>

<script>
import VueInputUi from 'vue-input-ui'

export default {
  name: "UserSignUp.vue",
  components: {
    VueInputUi
  },
  data() {
    return {
      firstName: 'Violet',
      lastName: 'McStinky',
      company: 'Dogs For Wineries Inc.',
      email: 'User@shot.com',
                telephoneNumber: '2027549814',
                value6: 'Hello world!',
                value7: null,
                value8: null,
                value9: null,
                value10: null,
                darkMode: false
            }
        }
    }
</script>

<style scoped>

</style>
